import { Reveal } from "@/components/motion";

export default function PageHeader({ kicker, title, sub, image, imagePosition = "object-center" }) {
  return (
    <section className="relative overflow-hidden border-b border-girder pt-20" data-testid={`page-header-${kicker?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" aria-hidden="true" className={`h-full w-full object-cover opacity-25 ${imagePosition}`} />
          <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-obsidian/85 to-obsidian" />
        </div>
      )}
      <div className="blueprint-grid absolute inset-0 opacity-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-hivis md:text-sm">{kicker}</p>
        </Reveal>
        <Reveal i={1}>
          <h1 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">{title}</h1>
        </Reveal>
        {sub && (
          <Reveal i={2}>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-slate-400 md:text-base">{sub}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
